import { useState } from "react";
import { ImgSrc } from "@config/image";
import theme from "@config/theme";
import Project from "./CommunityProject";
import Tags from "../Tags";

type CommunityProjectListProps = {
  category: string;
  projects: Project[];
  viewAll: boolean;
};

const CommunityProjectList = ({
  category,
  projects,
  viewAll,
}: CommunityProjectListProps) => {
  const [isViewingAll, setViewingAll] = useState(viewAll);
  return (
    <>
      <h2 id={category}>{category}</h2>
      <div className="featured-card-list">
        {(isViewingAll ? projects : projects.slice(0, 3)).map((project) => (
          <a key={project.id} href={project.url} target="_blank">
            <div className="featured-card">
              <img
                alt={`${project.title} banner`}
                src={project.coverImageUrl}
              />

              <div className="featured-card-content">
                <Tags tags={[project.difficulty]} />
                <h3>{project.title}</h3>
                <p>{project.description}</p>
                <p className="author">By {project.author}</p>

                <div className="stat-row">
                  <img
                    alt="Number of likes"
                    src={ImgSrc(`/images/icons/thumbs-up.svg`)}
                  />
                  <span>{project.respects}</span>

                  <img
                    alt="Number of views"
                    src={ImgSrc(`/images/icons/views.svg`)}
                  />
                  <span>{project.views}</span>
                </div>
              </div>
            </div>
          </a>
        ))}
      </div>

      {category !== "Trending" && (
        <button
          type="button"
          className="btn btnSecondary"
          onClick={() => setViewingAll(!isViewingAll)}
        >
          {isViewingAll ? "See less" : "See more"}
        </button>
      )}

      <style jsx>{`
        .featured-card {
          position: relative;
          padding-bottom: 1.5rem;
        }
        .featured-card::after {
          content: " ";
          background-image: url(${ImgSrc("/images/icons/launch.svg")});
          position: absolute;
          right: 1rem;
          bottom: 1rem;
          height: 25px;
          width: 25px;
        }
        .author {
          color: ${theme.colors.gray3};
        }
        .stat-row {
          display: flex;
          align-items: center;
          color: ${theme.colors.notehubBlueTintLighter};
        }
        .stat-row > img {
          margin-right: 5px;
        }
        .stat-row span {
          margin-right: 15px;
        }
        .stat-row img {
          height: 20px;
          width: 20px;
        }
      `}</style>
    </>
  );
};

export default CommunityProjectList;
